import prestashop from 'prestashop';
import Mustache from 'mustache';
import debounce from 'lodash/debounce';
import reject from 'lodash/reject';
import qs from 'qs';

if(document.getElementById('search-template')) 
{
    const SearchTemplate = document.getElementById('search-template').innerHTML;

    const input = document.querySelector('.js-search-input');

    const MAX_HITS = document.head.querySelector("[property~=search-max-hits][content]").content;
    const SEARCH_MIN_CHARS = 2;
    const DEBOUNCE_DURATION = 250;

    let controller = new AbortController();

    const overlay = document.querySelector('.js-search-overlay');

    if (overlay) {
        document.querySelectorAll('[data-toggle-search-overlay]').forEach((el) => {
            el.addEventListener('click', (event) => {
                event.preventDefault();
                event.stopPropagation();
                
                const isOpen = overlay.getAttribute('aria-expanded') === 'true';
                document.querySelector('.search-overlay').classList.toggle('search-overlay--opened', !isOpen);
                overlay.setAttribute('aria-expanded', !isOpen);

                if (!isOpen) {
                    document.querySelector('.js-search-input').focus();
                } else {
                    document.querySelector('.js-search-input').value = null;
                    setCounter();
                    resetView('.js-results-wrapper');
                    
                }
                return false;
            });
        });

        document.addEventListener('keyup', (event) => {
            if (event.keyCode == 27 && overlay.getAttribute('aria-expanded') === 'true') {
                document.querySelector('[data-toggle-search-overlay]').click();
            }
        })
    }

    input.addEventListener('input', debounce(async (event) => {
        controller.abort();
        controller = new AbortController();

        const value = event.target.value;
        const langIso = document.documentElement.lang;

        if (value.length < SEARCH_MIN_CHARS) {
            setCounter();
            resetView('.js-results-wrapper');
                
            return;
        }

        const params = {
            query: event.target.value,
            lang: langIso,
            id_shop: prestashop.shop.id_shop,
            time: new Date().getTime()
        }

        const endpoint = `/modules/elasticsearch/search.php?${qs.stringify(params)}`;
        let data;

        try {
            const response = await fetch(endpoint, {
                signal: controller.signal,
                cache: 'no-cache'
            });
            data = await response.json();
        } catch (e) {
            if (e.name !== 'AbortError') {
                setError('Erreur lors de la recherche.');
            }

            return;
        }

        setCounter(data.hits.length);

        displayView({
            collection: reject(data.hits, '_source.is_finished'),
            container: '.js-results',
            wrapper: '.js-results-wrapper'
        });

    }, DEBOUNCE_DURATION));

    const renderHit = (hit) => {
        hit._source.hasStateText = hit._source.state_text != null;
        if(prestashop.shop.isLocation) {
            hit._source['addToCartText'] = document.head.querySelector("[property~=rent-to-cart][content]").content;
        } else {
            hit._source['addToCartText'] = document.head.querySelector("[property~=add-to-cart][content]").content;
        }
        return Mustache.render(SearchTemplate, { product: hit._source, });
    }

    document.addEventListener('keyup', (event) => {
        let focusInput = document.querySelector('.js-search-input:focus');
        if (!focusInput) {
            return;
        }

        if (event.keyCode == 13) {
            input.blur();
        }
    })

    const displayView = ({ collection, container, wrapper }) => {
        const view = collection.map(renderHit);

        document.querySelector(container).innerHTML = view.join('');

        wrapper = document.querySelector(wrapper);
        wrapper.classList.toggle('search-overlay__results-wrapper--empty', view.length === 0);

        const overlay = document.querySelector('.js-search-overlay');
        overlay.setAttribute('aria-expanded', view.length > 0);
        const isOpen = overlay.getAttribute('aria-expanded') === 'true';
        overlay.classList.toggle('search-overlay--opened', !isOpen);
    }

    const resetView = (wrapper) => {
        wrapper = document.querySelector(wrapper);
        wrapper.classList.toggle('search-overlay__results-wrapper--empty', true);
    }

    const setError = (msg) => {
        const el = document.querySelector('.js-result-count');
        el.classList.toggle('search-overlay__result-count--error', true);
        el.innerHTML = msg;
    }

    const setCounter = (count = null) => {
        const el = document.querySelector('.js-result-count');
        el.classList.toggle('search-overlay__result-count--error', false);
        let msg = count;

        if (count == null) {
            msg = 'Tapez votre recherche';
        } else if (count == 0) {
            msg = 'Aucun résultat';
        } else if (count >= MAX_HITS) {
            msg = `Plus de ${MAX_HITS} résultats`;
        } else if (count == 1) {
            msg += ' résultat';
        } else if (count > 1) {
            msg += ' résultats';
        }

        el.innerHTML = msg;
    };
}


// WEBPACK FOOTER //
// ./themes/maisondubillard/_dev/js/components/instantsearch.js